import { ExtendableError } from './extendable_error.error'

export class OtpError extends ExtendableError {
  constructor ({factorId, token, repeatDetails, walletId}) {
    super('TFA required')
    this.errorType = 'TFA'
    this.meta = {
      walletId,
      factorId,
      token,
      repeatDetails
    }
  }
}

export class OTPCancelledError extends ExtendableError {
  constructor () {
    super('TFA cancelled')
  }

  showBanner () {
    // we need this to prevent showing errors when user cancels tfa verification
    return true
  }
}

export class PasswordFactorError extends ExtendableError {
  constructor (factorId, token, keychainData, salt, repeatDetails) {
    super('Password factor required')
    this.errorType = 'TFA'
    this.meta = {
      factorId,
      token,
      keychainData,
      salt,
      repeatDetails
    }
  }
}

export class TFARecoveryError extends ExtendableError {
  constructor ({walletId}) {
    super('TFA Recovery')
    this.errorType = 'TFA'
    this.meta = {
      walletId
    }
  }
}

export class TFAWrongCodeError extends ExtendableError {
  constructor () {
    super('Wrong TFA code')
    this.errorType = 'TFA'
  }
}

export class TFAExceededCodeError extends ExtendableError {
  constructor () {
    super('Too many wrong TFA attempts')
    this.errorType = 'TFA'
  }
}



// WEBPACK FOOTER //
// ./src/js/errors/tfa.errors.js